import styled from "styled-components";
import { Flex } from "sprout-ui-primitives";
const AppBarBase = styled(Flex)``;
AppBarBase.defaultProps = {
    bg: "#fdf6f0",
    alignItems: "center"
};
export default AppBarBase;
